import React from 'react';
import { render } from 'react-dom';
import ExpressWizard from './ExpressWizard/ExpressWizard';
import AdvModal from './CommonComponents/AdvModal';
import { ErrorBoundary } from './ErrorBoundary/ErrorBoundary';

AdvModal.setAppElement('#app');

setTimeout(
  () =>
    ADV.init().then(() => {
      render(
        <React.StrictMode>
          <ErrorBoundary>
            <ExpressWizard />
          </ErrorBoundary>
        </React.StrictMode>,
        document.getElementById('app'),
      );
    }),
  0,
);
